import { CloseIcon } from "../icons/CloseIcon";
import toast from "react-hot-toast";
import { useModal } from "../utils/demoProvider";
import { useState } from "react";
import { EMAIL_SERVICE, INTERNAL_RECIPIENTS } from "../utils/constants";
import { sendFormSubmissionDetails } from "../utils/templates";
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

const countries = [
  "Afghanistan",
  "Åland Islands",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belise",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, The Democratic Republic of The",
  "Cook Islands",
  "Costa Rica",
  "Cote D'ivoire",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-bissau",
  "Guyana",
  "Haiti",
  "Heard Island and Mcdonald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran, Islamic Republic of",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestinian Territory, Occupied",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Helena",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Pierre and Miquelon",
  "Saint Vincent and The Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and The South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Viet Nam",
  "Virgin Islands, British",
  "Virgin Islands, U.S.",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export default function DemoModal({ close }) {
  const { isOpen, closeModal } = useModal();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const form = new FormData(e.target);
    const payload = {
      ...Object.fromEntries(form),
    };

    try {
    // 1. Fetch RSA public key
      const res = await fetch(EMAIL_SERVICE + "public-key");
      const publicKey = await res.text();

      // 2. Generate random AES key & IV
      const aesKey = CryptoJS.lib.WordArray.random(32); // 256-bit
      const iv = CryptoJS.lib.WordArray.random(16);

      const payloadData = {
        to: INTERNAL_RECIPIENTS.join(", "),
        senderName: "AI Global Website",
        from: "no-reply@dataassistant.ai",
        subject: "Demo Request Form AI Africa",
        body: sendFormSubmissionDetails(payload, "Demo Request On AI Africa"),
        messageType: "html",
      };

      const encryptedPayload = CryptoJS.AES.encrypt(
        JSON.stringify(payloadData).toString(),
        aesKey,
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        },
      ).toString();

      // 4. Encrypt AES key with RSA public key
      const encrypt = new JSEncrypt();

      encrypt.setPublicKey(publicKey);
      const encryptedAesKey = encrypt.encrypt(
        aesKey.toString(CryptoJS.enc.Base64),
      );

      if (!encryptedPayload) {
        throw new Error("Failed to encrypt message. Please try again later.");
      }

      // Send encrypted payload to email service
      const response = await fetch(EMAIL_SERVICE + "send/encrypted", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          encryptedAesKey,
          iv: iv.toString(CryptoJS.enc.Base64),
          encryptedPayload,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to send encrypted email");
      }


      handleSuccess("Request sucessfully sent, We wil be in touch shortly");
      closeModal();
      e.target.reset();
    } catch (error) {
      toast.error("An error occurred. Please try again later.");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleSuccess = (message) => {
    toast.dismiss();
    toast.success(message, {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-60 z-[1000] flex items-center justify-center">
          <div className="bg-white w-full h-full md:max-h-[90vh] overflow-y-auto md:w-[680px] relative p-4 md:p-6 rounded-lg">
            <div className="flex justify-between items-start">
              <h1 className="font-extrabold text-xl">Demo Form</h1>
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 text-black text-2xl p-2 hover:bg-gray-400 hover:bg-opacity-20 rounded-full transition-colors z-10"
                aria-label="Close lightbox"
              >
                <CloseIcon />
              </button>
            </div>

            <div className="container">
              <form
                onSubmit={handleSubmit}
                className="mt-5 w-full max-w-[904px] mx-auto "
              >
                <div className="field">
                  <label
                    className="text-black text-base font-medium"
                    htmlFor="demo"
                  >
                    Which of our products are you interested in?
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="control">
                    <div className=" select relative">
                      <select
                        className="cursor-pointer form-input"
                        required
                        id="Which of our products are you interested in?"
                        name="Which of our products are you interested in?"
                        defaultValue=""
                      >
                        <option
                          className="!text-[#737373]"
                          style={{ color: "#737373" }}
                          value=""
                          disabled
                          data-placeholder="true"
                        >
                          Select Product
                        </option>
                        <option value={"AI Platform"}>AI Platform</option>
                        <option value={"PoweredbyAI"}>PoweredbyAI</option>
                        <option value={"Data Assistant"}>Data Assistant</option>
                      </select>
                      <div className="pointer-events-none absolute top-[15px] right-[10px] flex items-center px-2 text-white ">
                        <svg
                          width="15"
                          height="8"
                          viewBox="0 0 15 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.69184 0.55732C1.63377 0.499251 1.56483 0.453189 1.48896 0.421763C1.41309 0.390336 1.33177 0.37416 1.24965 0.37416C1.16753 0.37416 1.08621 0.390336 1.01034 0.421763C0.934471 0.453189 0.865533 0.499251 0.807465 0.55732C0.749395 0.615389 0.703333 0.684327 0.671907 0.760198C0.64048 0.836068 0.624304 0.917386 0.624304 0.999508C0.624304 1.08163 0.64048 1.16295 0.671907 1.23882C0.703333 1.31469 0.749395 1.38363 0.807465 1.4417L7.05746 7.6917C7.11551 7.74981 7.18444 7.79591 7.26031 7.82736C7.33619 7.85881 7.41752 7.875 7.49965 7.875C7.58179 7.875 7.66312 7.85881 7.73899 7.82736C7.81486 7.79591 7.88379 7.74981 7.94184 7.6917L14.1918 1.4417C14.3091 1.32442 14.375 1.16536 14.375 0.999508C14.375 0.833656 14.3091 0.674596 14.1918 0.557321C14.0746 0.440045 13.9155 0.37416 13.7497 0.37416C13.5838 0.37416 13.4247 0.440045 13.3075 0.557321L7.49965 6.36591L1.69184 0.55732Z"
                            fill="#3B82F6"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="field">
                  <label
                    className="text-black text-base font-medium"
                    htmlFor="Full name"
                  >
                    Full name
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="control">
                    <input
                      className="form-input bg-transparent"
                      required
                      type="text"
                      placeholder="Enter full name"
                      id="Full name"
                      name="Full name"
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-full justify-between gap-5">
                  <div className="field w-full">
                    <label
                      className="text-black text-base font-medium"
                      htmlFor="Work email"
                    >
                      Work email
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="control">
                      <input
                        className="form-input bg-transparent"
                        required
                        type="email"
                        placeholder="Enter work email"
                        id="Work email"
                        name="Work email"
                      />
                    </div>
                  </div>
                  <div className="field w-full">
                    <label
                      className="text-black text-base font-medium"
                      htmlFor="Phone number"
                    >
                      Phone number
                      <span className="text-red-500">*</span>
                    </label>
                    <div className="control">
                      <input
                        className="form-input bg-transparent"
                        required
                        type="text"
                        placeholder="Enter phone number"
                        id="Phone number"
                        name="Phone number"
                      />
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label
                    className="text-black text-base font-medium"
                    htmlFor="Country/Region"
                  >
                    Country/Region
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="control">
                    <div className="select relative" style={{ width: "100%" }}>
                      <select
                        id="Country/Region"
                        name="Country/Region"
                        required
                        defaultValue=""
                        className="cursor-pointer form-input w-full data-[placeholder=true]:text-[#737373]"
                      >
                        <option value="" disabled data-placeholder="true">
                          Select Country
                        </option>

                        {countries.map((country) => (
                          <option
                            key={country}
                            value={country}
                            className="text-black"
                          >
                            {country}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute top-[15px] right-[10px] flex items-center px-2 text-white ">
                        <svg
                          width="15"
                          height="8"
                          viewBox="0 0 15 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.69184 0.55732C1.63377 0.499251 1.56483 0.453189 1.48896 0.421763C1.41309 0.390336 1.33177 0.37416 1.24965 0.37416C1.16753 0.37416 1.08621 0.390336 1.01034 0.421763C0.934471 0.453189 0.865533 0.499251 0.807465 0.55732C0.749395 0.615389 0.703333 0.684327 0.671907 0.760198C0.64048 0.836068 0.624304 0.917386 0.624304 0.999508C0.624304 1.08163 0.64048 1.16295 0.671907 1.23882C0.703333 1.31469 0.749395 1.38363 0.807465 1.4417L7.05746 7.6917C7.11551 7.74981 7.18444 7.79591 7.26031 7.82736C7.33619 7.85881 7.41752 7.875 7.49965 7.875C7.58179 7.875 7.66312 7.85881 7.73899 7.82736C7.81486 7.79591 7.88379 7.74981 7.94184 7.6917L14.1918 1.4417C14.3091 1.32442 14.375 1.16536 14.375 0.999508C14.375 0.833656 14.3091 0.674596 14.1918 0.557321C14.0746 0.440045 13.9155 0.37416 13.7497 0.37416C13.5838 0.37416 13.4247 0.440045 13.3075 0.557321L7.49965 6.36591L1.69184 0.55732Z"
                            fill="#3B82F6"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="field">
                  <label
                    className="text-black text-base font-medium"
                    htmlFor="Company name"
                  >
                    Company name
                    <span className="text-red-500">*</span>
                  </label>
                  <div className="control">
                    <input
                      className="form-input bg-transparent"
                      required
                      type="text"
                      placeholder="Enter company name"
                      id="Company name"
                      name="Company name"
                    />
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-full justify-between gap-5">
                  <div className="field w-full">
                    <label
                      className="text-black text-base font-medium"
                      htmlFor="Company size"
                    >
                      Company size
                    </label>
                    <div className="control">
                      <div
                        className="select relative"
                        style={{ width: "100%" }}
                      >
                        <select
                          className="cursor-pointer form-input"
                          required
                          id="Company size"
                          style={{ width: "100%" }}
                          name="Company size"
                        >
                          <option>Select company size</option>
                          <option value={"1-10"}>1-10</option>
                          <option value={"10-20"}>10-20</option>
                          <option value={"20-50"}>20-50</option>
                          <option value={"50-100"}>50-100</option>
                          <option value={"100+"}>100+</option>
                        </select>
                        <div className="pointer-events-none absolute top-[15px] right-[10px] flex items-center px-2 text-white ">
                          <svg
                            width="15"
                            height="8"
                            viewBox="0 0 15 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.69184 0.55732C1.63377 0.499251 1.56483 0.453189 1.48896 0.421763C1.41309 0.390336 1.33177 0.37416 1.24965 0.37416C1.16753 0.37416 1.08621 0.390336 1.01034 0.421763C0.934471 0.453189 0.865533 0.499251 0.807465 0.55732C0.749395 0.615389 0.703333 0.684327 0.671907 0.760198C0.64048 0.836068 0.624304 0.917386 0.624304 0.999508C0.624304 1.08163 0.64048 1.16295 0.671907 1.23882C0.703333 1.31469 0.749395 1.38363 0.807465 1.4417L7.05746 7.6917C7.11551 7.74981 7.18444 7.79591 7.26031 7.82736C7.33619 7.85881 7.41752 7.875 7.49965 7.875C7.58179 7.875 7.66312 7.85881 7.73899 7.82736C7.81486 7.79591 7.88379 7.74981 7.94184 7.6917L14.1918 1.4417C14.3091 1.32442 14.375 1.16536 14.375 0.999508C14.375 0.833656 14.3091 0.674596 14.1918 0.557321C14.0746 0.440045 13.9155 0.37416 13.7497 0.37416C13.5838 0.37416 13.4247 0.440045 13.3075 0.557321L7.49965 6.36591L1.69184 0.55732Z"
                              fill="#3B82F6"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="field mb-4 w-full">
                    <label
                      className="text-black text-base font-medium"
                      htmlFor="How did you hear about us?"
                    >
                      How did you hear about us?
                    </label>
                    <div className="control">
                      <div
                        className="select relative"
                        style={{ width: "100%" }}
                      >
                        <select
                          className="cursor-pointer form-input"
                          required
                          id="How did you hear about us?"
                          style={{ width: "100%" }}
                          name="How did you hear about us?"
                        >
                          <option>Select</option>
                          <option value={"Google Search"}>Google Search</option>
                          <option value={"Referral"}>Referral</option>
                          <option value={"LinkedIn"}>LinkedIn</option>
                          <option value={"Facebook"}>Facebook</option>
                          <option value={"Twitter"}>Twitter</option>
                          <option value={"Instagram"}>Instagram</option>
                          <option value={"Email"}>Email</option>
                          <option value={"Others"}>Others</option>
                        </select>
                        <div className="pointer-events-none absolute top-[15px] right-[10px] flex items-center px-2 text-white ">
                          <svg
                            width="15"
                            height="8"
                            viewBox="0 0 15 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.69184 0.55732C1.63377 0.499251 1.56483 0.453189 1.48896 0.421763C1.41309 0.390336 1.33177 0.37416 1.24965 0.37416C1.16753 0.37416 1.08621 0.390336 1.01034 0.421763C0.934471 0.453189 0.865533 0.499251 0.807465 0.55732C0.749395 0.615389 0.703333 0.684327 0.671907 0.760198C0.64048 0.836068 0.624304 0.917386 0.624304 0.999508C0.624304 1.08163 0.64048 1.16295 0.671907 1.23882C0.703333 1.31469 0.749395 1.38363 0.807465 1.4417L7.05746 7.6917C7.11551 7.74981 7.18444 7.79591 7.26031 7.82736C7.33619 7.85881 7.41752 7.875 7.49965 7.875C7.58179 7.875 7.66312 7.85881 7.73899 7.82736C7.81486 7.79591 7.88379 7.74981 7.94184 7.6917L14.1918 1.4417C14.3091 1.32442 14.375 1.16536 14.375 0.999508C14.375 0.833656 14.3091 0.674596 14.1918 0.557321C14.0746 0.440045 13.9155 0.37416 13.7497 0.37416C13.5838 0.37416 13.4247 0.440045 13.3075 0.557321L7.49965 6.36591L1.69184 0.55732Z"
                              fill="#3B82F6"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full mx-auto">
                  <button
                    type="reset"
                    className="w-full md:w-[50%] mx-auto mt-2 text-center py-3 h-auto bg-transparent rounded-full text-sm border border-[#0173FF] text-[#0173FF]"
                  >
                    Clear All
                  </button>{" "}
                  <button
                    disabled={submitting}
                    type="submit"
                    role={"form"}
                    className="w-full md:w-[50%] mx-auto mt-2 text-center py-3 h-auto bg-[#0173FF] text-white rounded-full text-sm border border-[#0173FF]"
                  >
                    {submitting ? "Submitting" : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
